import PhoneVerificationContainer from './container'
import PhoneVerificationUI from './ui'
import PhoneVerificationReduxForm, {
  PhoneInputField,
} from './reduxFormContainer'
import * as utils from './utils'
import { removePhone } from './providers'

interface PhoneVerificationExports {
  PhoneVerificationContainer: typeof PhoneVerificationContainer
  PhoneVerificationUI: typeof PhoneVerificationUI
  PhoneVerificationReduxForm: typeof PhoneVerificationReduxForm
  PhoneInputField: typeof PhoneInputField
  utils: typeof utils
  providers: {
    removePhone: typeof removePhone
  }
}

const phoneVerificationExports: PhoneVerificationExports = {
  PhoneVerificationContainer,
  PhoneVerificationUI,
  PhoneVerificationReduxForm,
  PhoneInputField,
  utils,
  providers: {
    removePhone,
  },
}

export default phoneVerificationExports
